// /documents/:id – die eine Stelle, die einen Beleg zur Seite des Moduls leitet, dem seine Belegart gehört.
// Aufgaben, Benachrichtigungen, das Journal, das Audit-Protokoll und Suchtreffer ohne Belegart kennen nur die
// Kennung: Die Hülle schlägt die Belegart nach (platform.document.locate – mit dem Leserecht der Belegart am
// Standort des Belegs) und fragt die Manifeste nach `entityLinks['document:<belegart>']`.
import { Navigate, useParams } from 'react-router'
import { documentLocate } from '@modules/platform/contract'
import { documentRoute, useEntityLinks } from '../api/context'
import { useActionQuery } from '../api/hooks'
import { NotFound, PageSkeleton } from '../api/pages/states'

export function DocumentRoute() {
  const { id = '' } = useParams()
  const entityHref = useEntityLinks()
  const located = useActionQuery(documentLocate, { id })
  if (located.isPending) return <PageSkeleton title="Beleg" variant="detail" />
  if (!located.data) {
    return (
      <NotFound
        title="Diesen Beleg gibt es nicht"
        description="Er wurde verworfen, oder Sie dürfen ihn an seinem Standort nicht sehen."
      />
    )
  }
  const { type, typeTitle, number } = located.data
  const to = entityHref(`document:${type}`, id)
  // kein Modul der Oberfläche führt diese Belegart: nicht im Kreis leiten, sondern es sagen
  if (!to || to === documentRoute(id)) {
    return (
      <NotFound
        title={`${typeTitle}${number ? ` ${number}` : ''}: noch ohne eigene Seite`}
        description="Den Beleg gibt es, aber für seine Belegart ist in dieser Oberfläche keine Seite eingerichtet."
      />
    )
  }
  return <Navigate to={to} replace />
}
